import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import bgvdo from "../../Assets/video/videoplayback.mp4";
import AOS from "aos";

const CallBackForm = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false, offset: 100 });
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    service: "",
    message: "",
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, phone, email, message, service } = formData;

    if (!email || !name || !phone || !service) {
      toast.error("Please fill all required fields.");
      return;
    }

    try {
      const payload = {
        name,
        phone,
        email,
        message,
        service,
        status: "justConnection",
      };

      await axios.post(
        `${process.env.REACT_APP_API_URL}/inquiry/create-inquiry`,
        payload
      );

      toast.success("Request submitted! We'll contact you soon.");

      setFormData({
        name: "",
        phone: "",
        email: "",
        service: "",
        message: "",
      });
    } catch (error) {
      console.error("Form submission failed:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };

  return (
    <section className="relative w-full overflow-hidden bg-gray-100 text-white">
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 h-full w-full object-cover brightness-50"
      >
        <source src={bgvdo} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40 z-0" />

      {/* Content */}
      <div className="relative z-10 px-4 sm:px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Contact Info */}
          <div data-aos="fade-right">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-white/20 rounded-full flex items-center justify-center mb-6">
              <svg
                className="w-7 h-7 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
            </div>

            <p className="text-lg opacity-90 mb-2">Ready to discuss your project?</p>
            <p className="text-2xl sm:text-3xl font-bold mb-6">
              7737373307 <br /> 6372664851
            </p>

            <div className="space-y-4 text-sm text-white/90">
              <ContactItem
                icon={
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                }
                text="Mon-Fri: 9:00 AM - 6:00 PM"
              />
              <ContactItem
                icon={
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                }
                text="covenantsdevelopers@gmail.com"
              />
              <ContactItem
                icon={
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                }
                text="K7-29, Kalinga Nagar, Ghatikia, Bhubaneswar-751003"
              />
            </div>
          </div>

          {/* Form */}
          <div
            data-aos="fade-left"
            className="bg-white text-gray-900 rounded-lg p-6 sm:p-8 shadow-xl w-full max-w-xl mx-auto"
          >
            <h3 className="text-xl sm:text-2xl font-bold mb-3">Request a call back</h3>
            <p className="text-sm text-gray-600 mb-6">
              Please fill the form below, we will contact you soon!
            </p>

            <form onSubmit={handleSubmit} className="space-y-4 text-sm">
              <Input name="name" placeholder="Your Name" value={formData.name} onChange={handleInputChange} required />
              <Input name="phone" placeholder="Phone Number" type="tel" value={formData.phone} onChange={handleInputChange} required />
              <Input name="email" placeholder="Email" type="email" value={formData.email} onChange={handleInputChange} required />

              <textarea
                name="message"
                placeholder="Message"
                rows="4"
                value={formData.message}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#DE624D] focus:border-transparent outline-none resize-none"
              />

              <button
                type="submit"
                className="w-full bg-[#DE624D] hover:bg-[#c5553e] text-white font-semibold py-3 rounded-md transition duration-300 transform hover:scale-105"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

// Input field component
const Input = ({ name, type = "text", value, onChange, placeholder, required = false }) => (
  <input
    type={type}
    name={name}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#DE624D] focus:border-transparent outline-none"
    required={required}
  />
);

// Contact row component
const ContactItem = ({ icon, text }) => (
  <div className="flex items-start gap-4">
    <div className="min-w-[32px] h-8 bg-[#DE624D] rounded-full flex items-center justify-center">{icon}</div>
    <p className="text-sm leading-snug">{text}</p>
  </div>
);

export default CallBackForm;








// import { useState } from "react";
// import { motion } from "framer-motion";

// const RequestCallBack = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     service: "",
//     message: "",
//   });

//   const handleInputChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form submitted:", formData);
//   };

//   // Animation variants
//   const floatingCircle = {
//     animate: {
//       y: [0, -15, 0],
//       transition: {
//         duration: 6,
//         repeat: Infinity,
//         ease: "easeInOut",
//       },
//     },
//   };

//   const floatingCircle2 = {
//     animate: {
//       y: [0, 15, 0],
//       transition: {
//         duration: 5,
//         repeat: Infinity,
//         ease: "easeInOut",
//         delay: 1,
//       },
//     },
//   };

//   const floatingCircle3 = {
//     animate: {
//       x: [0, -15, 0],
//       transition: {
//         duration: 7,
//         repeat: Infinity,
//         ease: "easeInOut",
//         delay: 0.5,
//       },
//     },
//   };

//   const phoneIcon = {
//     initial: { scale: 0, rotate: -30 },
//     animate: {
//       scale: 1,
//       rotate: 0,
//       transition: {
//         type: "spring",
//         stiffness: 300,
//         damping: 10,
//       },
//     },
//     hover: {
//       rotate: [0, 10, -10, 0],
//       transition: {
//         duration: 0.8,
//       },
//     },
//   };

//   const textAnimation = {
//     initial: { opacity: 0, y: 20 },
//     animate: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.8,
//         ease: "easeOut",
//       },
//     },
//   };

//   return (
//     <section className="py-6 px-4 md:px-10 bg-gradient-to-br from-[#596893] to-[#4b5d8e] relative overflow-hidden">
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0 opacity-10">
//         <motion.div
//           className="absolute top-10 left-10 w-20 h-20 border-2 border-white rounded-full"
//           variants={floatingCircle}
//           animate="animate"
//         ></motion.div>
//         <motion.div
//           className="absolute bottom-20 right-20 w-16 h-16 border-2 border-white rounded-full"
//           variants={floatingCircle2}
//           animate="animate"
//         ></motion.div>
//         <motion.div
//           className="absolute top-1/2 left-1/4 w-12 h-12 border-2 border-white rounded-full"
//           variants={floatingCircle3}
//           animate="animate"
//         ></motion.div>

//         {/* Additional decorative elements */}
//         <motion.div
//           className="absolute top-1/3 right-1/4 w-8 h-8 border border-white rounded-full"
//           animate={{
//             scale: [1, 1.2, 1],
//             opacity: [0.6, 0.9, 0.6],
//           }}
//           transition={{
//             duration: 4,
//             repeat: Infinity,
//             ease: "easeInOut",
//           }}
//         ></motion.div>

//         <motion.div
//           className="absolute bottom-1/4 left-1/3 w-10 h-10 border border-white rounded-lg"
//           animate={{
//             rotate: [0, 15, 0, -15, 0],
//           }}
//           transition={{
//             duration: 8,
//             repeat: Infinity,
//             ease: "easeInOut",
//           }}
//         ></motion.div>
//       </div>

//       <div className="relative z-10">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           {/* Left Side - Contact Info with enhanced design */}
//           <div className="text-white relative">
//             <motion.div
//               className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mb-8"
//               variants={phoneIcon}
//               initial="initial"
//               animate="animate"
//               whileHover="hover"
//             >
//               <svg
//                 className="w-8 h-8 text-white"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                 />
//               </svg>
//             </motion.div>

//             <motion.p
//               className="text-lg opacity-90 mb-2"
//               variants={textAnimation}
//               initial="initial"
//               animate="animate"
//               transition={{ delay: 0.2 }}
//             >
//               Ready to discuss your project?
//             </motion.p>

//             <motion.p
//               className="text-3xl font-bold mb-8"
//               variants={textAnimation}
//               initial="initial"
//               animate="animate"
//               transition={{ delay: 0.3 }}
//             >
//               +91 9999 888877
//             </motion.p>

//             <motion.div
//               className="space-y-4"
//               variants={textAnimation}
//               initial="initial"
//               animate="animate"
//               transition={{ delay: 0.4 }}
//             >
//               <div className="flex items-center">
//                 <div className="w-8 h-8 bg-[#DE624D] rounded-full flex items-center justify-center mr-4">
//                   <svg
//                     className="w-4 h-4 text-white"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                 </div>
//                 <p>Mon-Fri: 9:00 AM - 6:00 PM</p>
//               </div>

//               <div className="flex items-center">
//                 <div className="w-8 h-8 bg-[#DE624D] rounded-full flex items-center justify-center mr-4">
//                   <svg
//                     className="w-4 h-4 text-white"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
//                     />
//                   </svg>
//                 </div>
//                 <p>covenants.con@info.in</p>
//               </div>

//               <div className="flex items-center">
//                 <div className="w-8 h-8 bg-[#DE624D] rounded-full flex items-center justify-center mr-4">
//                   <svg
//                     className="w-4 h-4 text-white"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
//                     />
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
//                     />
//                   </svg>
//                 </div>
//                 <p>123 Construction St, Business District, Dubai</p>
//               </div>
//             </motion.div>
//           </div>

//           {/* Right Side - Form (unchanged) */}
//           <div className="bg-white rounded-lg p-8 shadow-2xl">
//             <h3 className="text-2xl font-bold text-gray-900 mb-6">
//               Request a call back
//             </h3>
//             <p className="text-gray-600 mb-6">
//               Please fill the form below, we will contact you soon!
//             </p>

//             <form onSubmit={handleSubmit} className="space-y-4">
//               <div>
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Your Name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#DE624D] focus:border-transparent outline-none"
//                   required
//                 />
//               </div>

//               <div>
//                 <input
//                   type="tel"
//                   name="phone"
//                   placeholder="Phone Number"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#DE624D] focus:border-transparent outline-none"
//                   required
//                 />
//               </div>

//               <div>
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#DE624D] focus:border-transparent outline-none"
//                   required
//                 />
//               </div>

//               <div>
//                 <select
//                   name="service"
//                   value={formData.service}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#DE624D] focus:border-transparent outline-none"
//                   required
//                 >
//                   <option value="">Select Service / Other</option>
//                   <option value="civil-construction">Civil Construction</option>
//                   <option value="interior-design">Interior Design</option>
//                   <option value="hvac-services">HVAC Services</option>
//                   <option value="aluminium">Aluminium Work</option>
//                   <option value="other">Other</option>
//                 </select>
//               </div>

//               <div>
//                 <textarea
//                   name="message"
//                   placeholder="Message"
//                   rows="4"
//                   value={formData.message}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#DE624D] focus:border-transparent outline-none resize-none"
//                 ></textarea>
//               </div>

//               <button
//                 type="submit"
//                 className="w-full bg-[#DE624D] hover:bg-[#c5553e] text-white font-semibold py-3 px-6 rounded-md transition duration-300 ease-in-out transform hover:scale-105"
//               >
//                 Submit
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };
// export default RequestCallBack;
